export default __webpack_public_path__ + "static/driver-iphone-dash-mount-2680399e47bf9288eebf5f916d2684db.png";